<div class="mainstepcontent row w100">
  <div class="leftside col grow-1 gap-24" #contentContainer>
    <div class="col gap-16 w100">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step?.name }}</h1>
      </div>
      <!--
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
      -->
    </div>
    <div class="innerstep col">
      <h3
        [ngClass]="activeStep < 1 ? 'disabled' : ''"
        (click)="setStep(1)"
        *ngIf="activeStep !== 1"
      >
        The problem I solve
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 1"
        text1="The"
        text2="problem"
        text3="I solve"
        [stepPromptNumber]="activeStep"
        [autoFillDisabled]="activeStep !== 1"
        [streamId]="streamId"
        [stepId]="stepId"
        [roundId]="roundId"
        [closingPromptNumber]="closingPromptCounter"
        [control]="problemFormCOntrol"
        placeholder="Describe the key challenge your idea addresses..."
        (next)="nextStep('PROBLEM', $event)"
        (autofill)="autofill('PROBLEM', $event)"
        (supportme)="supportMe('PROBLEM', $event)"
      ></rr-ai-control>
      <rr-ai-control-result
        *ngIf="activeStep !== 1"
        (click)="setStep(1)"
        [content]="problemValue"
      ></rr-ai-control-result>
    </div>
    <div class="innerstep col">
      <h3
        *ngIf="activeStep !== 2"
        (click)="setStep(2)"
        [ngClass]="activeStep < 2 ? 'disabled' : ''"
      >
        The first people who will use my product
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 2"
        text1="The"
        text2="first users"
        text3="of my product"
        [stepPromptNumber]="activeStep"
        [communicationHistory]="communicationHistory"
        [streamId]="streamId"
        [stepId]="stepId"
        [roundId]="roundId"
        [closingPromptNumber]="closingPromptCounter"
        [control]="userFormCOntrol"
        placeholder="Start typing or use the AI button on the right →"
        (next)="nextStep('TARGET USER', $event)"
        (autofill)="autofill('TARGET USER', $event)"
        (supportme)="supportMe('TARGET USER', $event)"
      ></rr-ai-control>
      <rr-ai-control-result
        *ngIf="activeStep !== 2"
        [content]="userValue"
        (click)="setStep(2)"
      ></rr-ai-control-result>
    </div>
    <div class="innerstep col">
      <h3
        *ngIf="activeStep !== 3"
        [ngClass]="activeStep < 3 ? 'disabled' : ''"
        (click)="setStep(3)"
      >
        The solution in a nutshell
      </h3>
      <rr-ai-control
        *ngIf="activeStep === 3"
        text1="The"
        text2="solution"
        text3="in a nutshell"
        [stepPromptNumber]="activeStep"
        [streamId]="streamId"
        [stepId]="stepId"
        [roundId]="roundId"
        [control]="solutionFormCOntrol"
        [closingPromptNumber]="closingPromptCounter"
        (next)="nextStep('SOLUTION', $event)"
        placeholder="Start typing or use the AI button on the right →"
        [communicationHistory]="communicationHistory"
        (autofill)="autofill('SOLUTION', $event)"
        (supportme)="supportMe('SOLUTION', $event)"
      ></rr-ai-control>
      <rr-ai-control-result
        *ngIf="activeStep !== 3"
        (click)="setStep(3)"
        [content]="solutionValue"
      ></rr-ai-control-result>
    </div>
    <rr-divider></rr-divider>
    <div class="proceed col gap-16">
      <h4 class="strong">How shall we proceed?</h4>
      <div class="row gap-16 align-center">
        <!-- <rr-btn
          type="Primary"
          [disabled]="saveStreamStepDisabledStatus"
          (click)="
            saveStreamStepDisabledStatus === false ? startCLosingPrompt() : null
          "
          >Save Result</rr-btn
        > -->
        <rr-btn type="Link" class="underline" (click)="restartAgain()"
          >Reset & Start Again</rr-btn
        >
      </div>
    </div>
  </div>
  <div class="rightside col">
    <img src="/stepimages/basic-idea.png" alt="" />
  </div>
</div>

<rr-spinner *ngIf="loading"></rr-spinner>
